import React from 'react';
import { convertIntToMoney } from '../../../helpers/conversions';
import {
    TRIGGERS,
    triggerNoun,
    originLabel,
    amountOperatorLabel,
    taskTypeLabel,
    taskDueLabel,
    cardModeLabel,
    responsibleModeLabel,
    CONDITION_TYPES,
} from '../../../seeds/crm/automations';

const placeName = (rule) => {
    const p = rule?.pipeline?.name ?? 'pipeline';
    const s = rule?.stage?.name ?? 'coluna';
    return `${p} › ${s}`;
};

const conditionSegments = (conditions = []) => {
    const segs = [];
    (conditions || []).forEach((cond, index) => {
        segs.push({ text: index === 0 ? ', se ' : ' e ' });
        if (cond.type === CONDITION_TYPES.ORIGIN) {
            segs.push({ text: 'a origem for ' });
            segs.push({ text: originLabel(cond.value), chip: true });
        } else if (cond.type === CONDITION_TYPES.AMOUNT) {
            segs.push({ text: 'o valor for ' });
            segs.push({
                text: `${amountOperatorLabel(cond.operator)} ${convertIntToMoney(cond.value, true)}`,
                chip: true,
            });
        }
    });
    return segs;
};

// Quebra a regra em segmentos de texto, marcando os "chips" (valores destacáveis).
export const ruleSegments = (rule) => {
    if (!rule) return [];

    if (rule.trigger === TRIGGERS.CARD_ENTERED_STAGE) {
        const cfg = rule.action_config || {};
        const segs = [
            { text: 'Quando um card entrar em ' },
            { text: placeName(rule), chip: true },
            { text: ', criar uma tarefa de ' },
            { text: taskTypeLabel(cfg.task_type), chip: true },
        ];
        if (cfg.task_title) {
            segs.push({ text: ` “${cfg.task_title}”` });
        }
        segs.push({ text: ' ' });
        segs.push({ text: taskDueLabel(cfg.task_due_offset_days ?? 0), chip: true });
        segs.push({ text: '.' });
        return segs;
    }

    // Entrada de orçamento/pedido -> criar card
    const cfg = rule.action_config || {};
    const segs = [
        { text: 'Quando chegar ' },
        { text: triggerNoun(rule.trigger), chip: true },
    ];
    segs.push(...conditionSegments(rule.conditions));
    segs.push({ text: ', criar ' });

    if (rule.trigger === TRIGGERS.ORDER_CREATED) {
        segs.push({ text: cardModeLabel(cfg.card_creation_mode), chip: true });
        segs.push({ text: ' em ' });
        segs.push({ text: placeName(rule), chip: true });
        segs.push({ text: ', responsável ' });
        segs.push({ text: responsibleModeLabel(cfg.card_responsible_mode), chip: true });
    } else {
        segs.push({ text: 'um card em ' });
        segs.push({ text: placeName(rule), chip: true });
    }

    segs.push({ text: '.' });
    return segs;
};

// Versão em texto puro (tooltips, selos no board).
export const ruleToText = (rule) => ruleSegments(rule).map((s) => s.text).join('');

// Renderiza a frase (somente leitura), com os chips destacados.
export const RuleSentence = ({ rule }) => (
    <span className="rule-sentence">
        {ruleSegments(rule).map((seg, i) =>
            seg.chip ? (
                <span key={i} className="rule-sentence__chip">{seg.text}</span>
            ) : (
                <span key={i}>{seg.text}</span>
            )
        )}
    </span>
);

export default RuleSentence;
